const SHOW = 'show';
const CLOSE = 'close';

const state = {
    name: null
};

const actions = {
    [SHOW]: ({ commit }, modalName) => {
        commit(SHOW, modalName);
    },
    [CLOSE]: ({ state, commit }) => {
        commit(CLOSE);
    }
};

const mutations = {
    [SHOW]: (state, modalName) => state.name = modalName,
    [CLOSE]: (state) => state.name = null
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./skins/xkiosk/data/modals.js